import { Typography } from "@mui/material";
import styled from "styled-components";

export const StyledHeading = styled(Typography)`
`